import React, { MouseEvent, useCallback, useState } from 'react';

import Link from 'next/link';
import { useDispatch, useSelector } from 'react-redux';

import { IState } from 'store';
import { objectIsEmpty } from 'utils/objectEmpty';
import { IUserProps, signOut } from 'store/modules/profile';

import MobileNavigationTree from './MobileNavigationTree';

import * as S from './styles';

interface MenuMobileProps {
  onClose?(): void;
}

export default function MenuMobile({ onClose }: MenuMobileProps) {
  const dispatch = useDispatch();
  const user = useSelector<IState, IUserProps>(state => state.profile.user);

  const [itsClosing, setItsClosing] = useState(false);

  const handleControlPropagation = useCallback(
    (e: MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    },
    [],
  );

  function handleCloseModal() {
    setItsClosing(true);
    setTimeout(() => {
      onClose();
    }, 200);
  }

  const handleSignOut = useCallback(() => {
    dispatch(signOut({}));
  }, [dispatch]);

  return (
    <S.ContainerWrapper
      className="menu-mobile-wrapper"
      onClick={handleCloseModal}
      role="presentation"
    >
      <S.Container
        onClick={handleControlPropagation}
        className={`menu-mobile${itsClosing ? ' closing' : ''}`}
      >
        <div className="header-close">
          <img
            src="/images/icons/x.svg"
            alt="Fechar"
            className="icon close-icon"
            onClick={handleCloseModal}
          />
        </div>

        <div className="header-nav-user">
          <img
            src="/images/icons/user.svg"
            alt="Usuário"
            className="icon user-icon"
          />

          <div className="header-nav-user-info">
            {!objectIsEmpty(user) ? (
              <Link href="/central-do-cliente/pedidos" passHref>
                <a href="">
                  <p>Olá, {user.nome}</p>
                  <strong>Minha conta</strong>
                </a>
              </Link>
            ) : (
              <Link href="/identificacao">
                <a href="">
                  <p>Olá, Visitante!</p>
                  <strong>Cadastre-se | Login</strong>
                </a>
              </Link>
            )}
          </div>
        </div>

        <MobileNavigationTree />

        {!objectIsEmpty(user) && (
          <>
            <Link href="/central-do-cliente/pedidos">
              <a>Meus pedidos</a>
            </Link>
            <Link href="/central-do-cliente/favoritos">
              <a>Favoritos</a>
            </Link>
            <Link href="/central-do-cliente/alterar-cadastro">
              <a>Alterar cadastro</a>
            </Link>
            <Link href="/central-do-cliente/alterar-senha">
              <a>Alterar senha</a>
            </Link>
          </>
        )}
        <a
          href="https://atendimento.ultrafarma.com.br/hc/pt-br"
          target="_blank"
          rel="noopener noreferrer"
        >
          SAC
        </a>
        <Link href="/central-do-cliente/pedidos">
          <a>Acompanhar pedido</a>
        </Link>
        {/* <Link href="/ultracompare">
          <a>
            <img
              src="/images/ultra-compare-logo.svg"
              alt="Ultra Compare"
              className="ultra-compare-image-1"
            />
          </a>
        </Link> */}
        <Link href="/clube-sidney-oliveira">
          <a>
            <img
              src="/images/clube-sidney-oliveira-logo.svg"
              alt="Clube Sidney Oliveira"
              className="clube-sidney-oliveira-logo"
            />
          </a>
        </Link>
        {/* <Link href="/ultrapremio">
          <a>
            <img
              src="/images/ultra-premio-logo.png"
              alt="Ultra Prêmio"
              className="ultra-premio-image-1"
            />
          </a>
        </Link> */}
        {/* <Link href="/ultracompare">
          <a>
            <img
              src="/images/ultra-compare-logo.png"
              alt="Ultra Compare"
              className="ultra-compare-image-1"
            />
          </a>
        </Link> */}
        {!objectIsEmpty(user) && (
          <strong className="sign-out" onClick={handleSignOut}>
            Sair
          </strong>
        )}

        <div className="group-ultra-brands">
          <strong>Marcas do Grupo</strong>

          <div>
            <a href="https://www.ultrafarma.com.br/" target="_blank">
              <img
                src="/images/ultrafarma-logo.png"
                alt="Ultrafarma"
                className="ultrafarma"
              />
            </a>
            <a href="https://www.oticasultrafarma.com.br/" target="_blank">
              <img
                src="/images/brands-group-ultra/oticas-ultrafarma-white.png"
                alt="Óticas Ultrafarma"
              />
            </a>
            <a href="https://www.ultratakado.com/" target="_blank">
              <img
                src="/images/brands-group-ultra/ultratakado-white.png"
                alt="Ultratakado"
              />
            </a>
          </div>
        </div>
      </S.Container>
    </S.ContainerWrapper>
  );
}
